import { Button } from '@shopify/polaris'
import React, { useState } from 'react'
import { DI, DIProps } from '../../../../Core';
import { DownloadIcon } from './SVGs';
interface PropsI extends DIProps {
    obj: any
}

const DownloadLabel = ({ obj, ...props }: PropsI) => {
    const [loader, setLoader] = useState(false)

    const downloadLabel = (data: any, obj: any) => {
        setLoader(true)
        props.di.POST('amazon/amazon-buy-shipping/getShipmentDocuments', data).then((response) => {
            if (response.success) {
                let code = response?.data?.[0]?.packageDocumentDetail?.packageDocuments?.find((a: any) => a.type === 'LABEL');
                if (!code?.contents) return;
                let fetchDataModified = `data:${code?.format?.toLowerCase() ?? 'pdf'};base64,${code.contents}`;
                let a = document.createElement("a");
                a.href = fetchDataModified;
                a.download = `label-${obj?.['marketplace_reference_id'] ?? "N/A"}.${code?.format?.toLowerCase() ?? 'pdf'}`;
                a.click();
            } else {
                props.error(response?.message ?? 'Failed to download label')
            }
            setLoader(false)
        })
    }

    return (
        <Button
            icon={DownloadIcon}
            loading={loader}
            onClick={() => { downloadLabel(obj?.shipping_services ?? {}, obj) }}


            removeUnderline
            variant="monochromePlain" />
    );
}

export default DI(DownloadLabel)